<template>
  <div class="rows settlement-details-search">
    <Form ref="formInline" :model="formInline" :label-width="80" inline>
      <!-- <FormItem label="分类">
        <Select
          v-model="formInline.type"
          style="width: 150px"
          @on-change="onTypeChange"
        >
          <Option
            v-for="item in checkTypeData"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</Option>
        </Select>
      </FormItem> -->
      <!-- <FormItem label="状态">
        <Select
          v-model="formInline.status"
          :disabled="formInline.type == 0"
          style="width: 150px"
        >
          <Option
            v-for="item in statusData"
            :key="item.value"
            :value="item.value"
            :disabled="item.label == '全部' && formInline.type != '0'"
            >{{ item.label }}</Option
          >
        </Select>
      </FormItem> -->
      <FormItem class="must" label="监管银行">
        <Select v-model="formInline.bankId" style="width: 150px">
          <Option
            v-for="item in bankData"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="课程机构">
        <!-- -->
        <div v-if="portOrg == 1 || portOrg == 0">
          <!-- <SearchSelectOrgByEdu
            :orgId="formInline.orgId"
            @on-org-change="onOrgChange"
          ></SearchSelectOrgByEdu> -->
          <SearchSelectOrg
            ref="orgRef"
            :edu-id="portOrg == 1 ? userInfo.orgId : detailsData.eduId"
            :org-id="formInline.orgId"
            :tab="1"
            @on-org-change="onOrgChange"
          ></SearchSelectOrg>
        </div>
        <!-- <div v-if="portOrg == 0">
          <SearchSelectOrgForEdu
            ref="orgRef"
            :org-id="formInline.orgId"
            @on-org-change="onOrgChange"
          >
          </SearchSelectOrgForEdu>
        </div> -->
      </FormItem>

      <FormItem label="收款单位">
        <SearchSelectAccount ref="accountRef"></SearchSelectAccount>
      </FormItem>

      <FormItem label="对账状态">
        <Select
          v-model="formInline.approvalSts"
          placeholder="请选择对账状态"
          class="search-select-430"
        >
          <Option
            v-for="item in rlStatusData"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="结算状态">
        <Select v-model="formInline.settleSts" style="width: 150px">
          <Option
            v-for="item in stStatusData"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</Option>
        </Select>
      </FormItem>
      <Button
        type="primary"
        style="margin-left: 40px"
        @click="handleSubmit('formInline')"
      >查询</Button>
    </Form>
  </div>
</template>

<script>
import { checkTypeData, statusData, orgStatusData, rlStatusData } from '../data/SettlementDetailsSearch';
import { stStatusData } from '../data/SettlementDetailsSearch';
import { bankData, bankTypeMap } from '../data/SearchBlock.js';
import SearchSelectOrgByEdu from './SearchSelectOrgByEdu.vue';
import SearchSelectOrgForEdu from './SearchSelectOrgForEdu.vue';
import SearchSelectOrg from './SearchSelectOrg.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import SearchSelectAccount from '@c/searchBlock/SearchSelectAccount.vue';
import { mapState, mapActions } from 'vuex';
export default {
  components: {
    SearchSelectOrgByEdu,
    SearchSelectOrgForEdu,
    SearchSelectOrg,
    SearchSelectAccount
  },
  props: {
    beginTime: {
      type: String,
      default: ''
    },
    detailsData: {
      type: Object,
      default: () => null
    }
  },

  data() {
    return {
      checkTypeData: checkTypeData,
      statusData: statusData,
      bankData: [],
      stStatusData,
      portOrg: localStorage.getItem('portOrg'),
      rlStatusData: rlStatusData,
      formInline: {
        type: '0',
        status: '0',
        orgId: '0',
        bankId: '0',
        orgName: '',
        approvalSts: '-1',
        settleSts: '-1',
        settlementSheetOrgId: '',
        acctName: ''
      }

    };
  },
  computed: {
    ...mapState({
      settlementDetailsSearch: state => state.orderCenter.settlementDetailsSearch,
      userInfo: state => state.userInfo
    })
  },
  created() {
    this.initSearchData();
  },
  methods: {
    ...mapActions('orderCenter', [
      'updateSettlementDetailsSearch'
    ]),
    async getBankIdOrgByAreaCode() {
      const res = await orderCenterApi.getBankIdOrgByAreaCode();
      if (res.status == 200) {
        this.bankData = res.message.map(item => {
          return {
            label: bankTypeMap[Number(item.bankId)],
            value: item.bankId,
            bankId: item.bankId
          };
        });
        if (this.bankData.length > 0) {
          // this.formInline.bankId = this.bankData[0]['value']
          for (let i = 0; i < this.bankData.length; i++) {
            if (+this.bankData[i].value !== 0) {
              this.formInline.bankId = this.bankData[i].value;
              break;
            }
          }
          this.handleSubmit('formInline');
        }
      }
    },
    initSearchData() {
      if (this.settlementDetailsSearch) {
        this.formInline.type = this.settlementDetailsSearch.type;
        this.formInline.status = this.settlementDetailsSearch.status;
        //   this.formInline.orgId = this.settlementDetailsSearch.orgId
        this.formInline.bankId = this.settlementDetailsSearch.bankId;
        //   this.formInline.orgName = this.settlementDetailsSearch.orgName

        this.handleSubmit();
      }
      this.getBankIdOrgByAreaCode();
    },
    // 缓存初始化 分类 状态参数

    onOrgChange(org) {
      console.log(org, 'org');
      this.formInline.orgId = org.orgId;
      this.formInline.orgName = org.orgName;
    },
    handleSubmit() {
      const res = this.checkParameter(); let data;
      if (res.code != 200) {
        return this.$Message.warning(res.str);
      }
      data = this.getParameter();
      console.log(data, '123321123');
      this.updateSettlementDetailsSearch(this.formInline);
      this.$emit('on-finish', data);
    },
    onTypeChange(val) {
      console.log(val);
      if (val == '1') {
        this.statusData = orgStatusData;
      } else {
        this.statusData = statusData;
      }
      if (val == '0') {
        this.formInline.status = '0';
      } else {
        if (this.formInline.status == '0') {
          this.formInline.status = '1';
        }
      }
    },
    // 获取参数
    getParameter() {
      const statementSts = 0; const { status, approvalSts } = this.formInline;
      if (this.$refs.accountRef) {
        //   const { acctName, settlementSheetOrgId } = await this.$refs.accountRef.getVal();
        this.formInline.acctName = this.$refs.accountRef.acctName;
        this.formInline.settlementSheetOrgId = this.$refs.accountRef.settlementSheetOrgId;
      }

      return {
        approvalSts: approvalSts == -1 ? '' : approvalSts,
        bankId: this.formInline.bankId,
        orgId: this.formInline.orgId == 0 ? '' : this.formInline.orgId,
        eduId: this.portOrg == 1 ? this.userInfo.orgId : this.detailsData.eduId,
        beginTime: this.beginTime,
        orgName: this.formInline.orgName,
        settleSts: this.formInline.settleSts == -1 ? null : this.formInline.settleSts,
        settlementSheetOrgId: this.formInline.settlementSheetOrgId == 0 ? '' : this.formInline.settlementSheetOrgId
      };
    },
    // 校验参数
    checkParameter() {
      const data = {
        code: 200,
        str: ''
      };
      // if (this.formInline.type == 0) {
      //   data.str = '请选择分类'
      //   data.code = 501
      //   return data
      // }
      if (this.formInline.type != 0 && this.formInline.status == 0) {
        data.str = '请选择状态';
        data.code = 501;
        return data;
      }
      if (this.formInline.bankId == 0) {
        data.str = '请选择银行';
        data.code = 501;
        return data;
      }
      // if (this.formInline.orgId == 0) {
      //   data.str = '请选择机构'
      //   data.code = 501
      //   return data
      // }
      return data;
    }

  }
};

</script>
<style lang="scss" scoped>
@import '@/assets/scss/common';
</style>

<style lang="scss"  >
.settlement-details-search {
  .must {
    .ivu-form-item-label {
      &:before {
        content: '*';
        display: inline-block;
        color: red;
      }
    }
  }
}
</style>
